import { render } from 'react-dom'
import React from 'react'
import CandidatePage from './components/CandidatePage.jsx'
import alterForm from './alterForm.js'

const candidateAppContainer = document.getElementById('candidates-app')

if (candidateAppContainer) {
  document.addEventListener('DOMContentLoaded', () => {
    render(<CandidatePage />, candidateAppContainer)
  })
}
